import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import {
  SwitchCompanyResponseDto,
  SwitchConfigurationService,
} from '@wealthlane/api-services/wealthlane-customer-service';
import { OptionType } from '../../types/common';
import {
  CompanySsoConfigurationService,
  Wealthlane_Dtos_SsoProvider_CreateUpdateCompanySsoConfigurationDto,
} from '@wealthlane/api-services/wealthlane-identity-service';
import { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '@wealthlane/api-services/wealthlane-award-service';

const usePostCompanySso = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onSuccess: () => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload?: Wealthlane_Dtos_SsoProvider_CreateUpdateCompanySsoConfigurationDto) => {
      const response = await handleRequest(
        CompanySsoConfigurationService.postApiIdentityApiAppCompanySsoConfiguration(payload)
      );
      return response;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('getCompanySsoConfigList');
        onSuccess();
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostCompanySso;
